import { render, staticRenderFns } from "./ValidaCodigo.vue?vue&type=template&id=2305d526&scoped=true&"
import script from "./ValidaCodigo.vue?vue&type=script&lang=js&"
export * from "./ValidaCodigo.vue?vue&type=script&lang=js&"
import style0 from "./ValidaCodigo.vue?vue&type=style&index=0&id=2305d526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305d526",
  null
  
)

export default component.exports